<template>
  <v-container v-if="!review">
    <Porting />

    <template v-if="porting === 'y'">
      <v-divider class="my-6" />

      <div class="text-h4 mb-2">Enter a phone number to move</div>
      <p class="mb-4">
        Enter one phone number you want to move, we will process any others later.
      </p>

      <v-text-field v-model="product.loa_phone" dense hide-details placeholder="(555) 555-5555"
        v-mask="'(###) ###-####'" />

      <v-divider class="my-6" />
      <TollfreePorting />
      <!-- <div>
        <div v-if="invoiceFiles.length === 0">
          <v-container class="pa-0">
            <div class="text-h4 mb-2">Confirm the details of your company</div>
            <p class="mb-4">As appears on your current invoice</p>

            <v-text-field :value="product.business_name || product.tf_company_name || ''"
              label="Business / Company Name" hint="Name on current invoice, if applicable" persistent-hint class="mb-4"
              @input="product.business_name = $event; product.tf_company_name = $event" />

            <AddressAutocomplete :value="(loaAddress && loaAddress.streetAddress) ? loaAddress : tollfreeAddress"
              @registerAddressChange="
                setAddress($event);

              product.loa_address = ($event && $event.streetAddress) || null;
              product.loa_suite = ($event && $event.suite) || null;
              product.loa_city = ($event && $event.city) || null;
              product.loa_state = ($event && $event.state) || null;
              product.loa_zip = ($event && $event.zip) || null;

              product.tf_address = ($event && $event.streetAddress) || null;
              product.tf_suite = ($event && $event.suite) || null;
              product.tf_city = ($event && $event.city) || null;
              product.tf_state = ($event && $event.state) || null;
              product.tf_zip = ($event && $event.zip) || null;
              " />

            <v-text-field v-model="product.tfc_fax" label="Fax" v-mask="'(###) ###-####'" />
          </v-container>
        </div>

        <div class="text-h4">Authorized Contact + Signature</div>
        <p>Please provide us with an authorized contact.</p>
        <Contact :d="contactData" @assignContact="assignContact" />
        <ESignature :value="product.tf_sig_name || product.loa_name || ''"
          :accepted="product.tf_accepted || product.loa_accepted || 'n'" :preamble="signaturePreamble"
          :acceptText="signatureAcceptText" @input="product.tf_sig_name = $event; product.loa_name = $event"
          @update:accepted="product.tf_accepted = $event; product.loa_accepted = $event" />

        <div class="text-h4 mb-2">What is your billing telephone number?</div>
        <v-text-field v-model="product.listing_phone" prepend-icon="mdi-phone" label="Billing Telephone Number"
          v-mask="'(###) ###-####'" />
      </div> -->

      <!-- <div class="text-h4">Caller ID Name</div>
      <p>Please choose a Caller ID Name.</p>
      <v-row>
        <v-col cols="12" md="6">
          <v-form ref="caller_id" lazy-validation>
            <v-text-field :value="getProductInfo().caller_id" label="Caller ID Name" hint="(Max. 15 Characters)"
              persistent-hint :rules="callerIDRules" @input="validateCid" maxlength="15"></v-text-field>
          </v-form>
        </v-col>
      </v-row> -->

      <!-- <div class="text-h4">911 Address Location</div>
      <p>Please fill out the 911 address for the Location you are requesting.</p>
      <v-container>
        <AddressAutocomplete :value="e911Address" @registerAddressChange="sete911Address" />
      </v-container>
      -->
      <!-- <div v-if="tfNumbers === 'y'">
        <div class="text-h4">Let us know what toll-free numbers you are redirecting</div>
        <p>If you know your numbers you may enter them here</p>
        <v-container>
          <v-row v-for="(request, i) in product.tf_phone" :key="i">
            <v-col>
              <v-text-field v-model="product.tf_phone[i]" label="Toll Free Number"
                v-mask="'(###) ###-####'"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="product.rtn_phone[i]" label="Number to direct calls to (Ring-to Number)"
                v-mask="'(###) ###-####'"></v-text-field>
            </v-col>
            <v-col cols="auto">
              <v-btn color="error" text @click="deleteNumber(i)">Delete</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="third" class="white--text" @click="addNumber">
                List another tollfree number
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div> -->

      <!-- <div class="text-h4">Do you want a white page listing?</div>
      <v-radio-group :value="getProductInfo().white_page_listing" @change="setWhitePageAnswer">
        <template v-slot:label>
          <div>
            Let us know if you would like to
            <strong>White Page List</strong>
            your company's phone number.
          </div>
        </template>
        <v-radio label="Yes, I want to white page list" value="y"></v-radio>
        <v-radio label="No, I do not want to white page list" value="n"></v-radio>
      </v-radio-group> -->

      <!-- <div v-if="getProductInfo().white_page_listing === 'y'">
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <div class="subtitle-2">What is the company name?</div>
              <v-text-field v-model="product.listing_company_name" label="Company Name"></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-container>
          <p>Please fill out the company address for the white page listing you are requesting.</p>
          <AddressAutocomplete :value="wplAddress" @registerAddressChange="setWhitePageAddress" />
        </v-container>
      </div> -->
    </template>

    <!-- <v-dialog v-model="rangeDialog.open" max-width="520">
      <v-card>
        <v-card-title class="text-h6">
          {{ rangeDialog.rowIndex == null ? 'Add number range' : 'Set number range' }}
        </v-card-title>

        <v-card-text>
          <v-form ref="rangeForm" v-model="rangeDialog.valid">
            <v-text-field v-model="rangeDialog.start" label="Start number" v-mask="'(###) ###-####'"
              :rules="rangeStartRules" @input="rangeDialogTouched" />
            <v-text-field v-model="rangeDialog.end" label="End number" v-mask="'(###) ###-####'" :rules="rangeEndRules"
              @input="rangeDialogTouched" />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="closeRangeDialog">Cancel</v-btn>
          <v-btn color="primary" text :disabled="!rangeDialog.valid" @click="saveRange">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-container>

  <div v-else>
    <ReviewItem label="Are you moving any numbers from your previous provider?"
      :value="product.porting === 'y' ? 'Yes' : 'No'" />

    <div v-if="product.porting === 'y'">
      <!-- <div class="pt-3">
        What phone numbers are you moving?&ensp;
        <v-simple-table dense>
          <thead>
            <tr>
              <th class="text-left">Port request</th>
            </tr>
          </thead>
          <tbody>
            {{ reviewPortRows }}
          </tbody>
        </v-simple-table>
      </div> -->

      <!-- <ReviewItem label="Business Name" :value="product.business_name" />
      <ReviewItem label="Business Address" :value="loaAddressString" />
      <ReviewItem label="What is your Caller ID Name?" :value="getProductInfo().caller_id" /> -->

      <ReviewItem label="Are you porting any tollfree numbers from your previous provider?"
        :value="product.tf_numbers === 'y' ? 'Yes' : 'No'" />
      <!-- <ReviewItem label="Business Name" :value="product.tf_company_name" />
      <ReviewItem label="Business Address" :value="tfAddressString" /> -->

      <!-- <ReviewItem label="Do you want a white page listing?"
        :value="product.white_page_listing === 'y' ? 'Yes' : 'No'" /> -->
      <!-- <ReviewItem v-if="product.white_page_listing === 'y'" label="What is the company name?"
        :value="product.listing_company_name" />
      <ReviewItem v-if="product.white_page_listing === 'y'" label="What is the listing phone number?"
        :value="product.listing_phone" />
      <ReviewItem v-if="product.white_page_listing === 'y'" label="Listing Address" :value="listingAddressString" /> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
// import Upload from '@/components/subforms/Upload.vue';
// import AddressAutocomplete from '@/components/formfields/AddressAutocomplete.vue';
import Porting from '@/components/cards/Porting.vue';
import ReviewItem from '@/components/ReviewItem.vue';
import TollfreePorting from '@/components/cards/TollfreePorting.vue';
// import Contact from '@/components/formfields/Contact.vue';

export default {
  name: 'LetterOfAgency',
  props: {
    review: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      product: {},
      uploadedFiles: [],
      initialRowCount: 6,
      minEmptyTailRows: 2,
      portDateHint: 'Typical Firm Order Confirmation (FOC) timeframe is 7-14 business days (M-F) from submission. Requests sooner than 7 days may be subject to an expedite fee. Fiber typically takes 60-120 days.',
      signaturePreamble: `
        The undersigned hereby authorizes Local Exchange Carriers of MI, Inc. (LECMI) to port the
        telephone number(s) listed above away from the current carrier. This includes authorization
        for LECMI to request Customer Service Records, or CSRs, for telephone numbers in order to
        facilitate successful porting.
      `,
      signatureAcceptText: 'I authorize LECMI to port my numbers listed in this document and agree to digitally sign with my e-signature.',
      rangeDialog: {
        open: false,
        valid: false,
        rowIndex: null,
        start: '',
        end: '',
        touched: false,
      },
      callerIDRules: [
        (v) => (v && v.length <= 15) || 'Caller ID Name must be less than 15 characters',
      ],
    };
  },
  computed: {
    ...mapGetters(['getProductIdSelected', 'getProductInfo', 'getQuoteFacts', 'getAllFiles', 'contactsList']),
    porting() {
      return this.getProductInfo().porting;
    },
    invoiceFiles() {
      return _.filter(this.getAllFiles, (file) => (
        file.tags.product_id === this.getProductIdSelected
        && file.tags.field_name === 'loa_invoice'
      ));
    },
    portRows() {
      const phones = this.product.loa_phone || [];
      const rows = [];

      for (let i = 0; i < phones.length; i += 1) {
        rows.push({ index: i });
      }

      return rows;
    },
    loaAddress() {
      const address = {};
      if (this.product.loa_address != null) {
        address.streetAddress = this.product.loa_address;
        address.suite = this.product.loa_suite;
        address.city = this.product.loa_city;
        address.state = this.product.loa_state;
        address.zip = this.product.loa_zip;
      }
      return address;
    },
    loaAddressString() {
      return `${this.product.loa_address}, ${this.product.loa_city}, ${this.product.loa_state} ${this.product.loa_zip}`;
    },
    reviewPortRows() {
      return this.product.loa_phone;
      // const rows = [];
      // const phones = this.product.loa_phone || [];
      // const ends = this.product.loa_endrange_phone || [];
      // const len = Math.max(phones.length, ends.length);

      // for (let i = 0; i < len; i += 1) {
      //   const start = phones[i];
      //   const end = ends[i];

      //   if (start || end) {
      //     rows.push({
      //       start,
      //       end,
      //       display: end ? `${start}-${end}` : start,
      //     });
      //   }
      // }

      // return rows;
    },
    rangeStartRules() {
      return [
        (v) => !!v || 'Start number is required',
        (v) => this.isTenDigitPhone(v) || 'Enter a valid 10-digit phone number',
      ];
    },
    rangeEndRules() {
      return [
        (v) => !!v || 'End number is required',
        (v) => this.isTenDigitPhone(v) || 'Enter a valid 10-digit phone number',
      ];
    },
    tfNumbers() {
      return this.getProductInfo().tf_numbers;
    },
    contactData() {
      return {
        fullname: this.product.tfc_auth_contact,
      };
    },
    tollfreeAddress() {
      const address = {};
      if (this.product.tf_address != null) {
        address.streetAddress = this.product.tf_address;
        address.suite = this.product.tf_suite;
        address.city = this.product.tf_city;
        address.state = this.product.tf_state;
        address.zip = this.product.tf_zip;
      }
      return address;
    },
    wplAddress() {
      const address = {};
      if (this.product.listing_address) {
        // Use saved data if it exists
        address.streetAddress = this.product.listing_address;
        address.suite = this.product.listing_suite;
        address.city = this.product.listing_city;
        address.state = this.product.listing_state;
        address.zip = this.product.listing_zip;
      }
      return address;
    },
    tfAddressString() {
      return `${this.product.tf_address}, ${this.product.tf_city}, ${this.product.tf_state} ${this.product.tf_zip}`;
    },
    listingAddressString() {
      return `${this.product.listing_address}, ${this.product.listing_city}, ${this.product.listing_state} ${this.product.listing_zip}`;
    },
    e911Address() {
      return {
        streetAddress: this.product.e911_address,
        suite: this.product.e911_suite,
        city: this.product.e911_city,
        state: this.product.e911_state,
        zip: this.product.e911_zip,
      };
    },
    e911AddressString() {
      return `${this.product.e911_address}, ${this.product.e911_city}, ${this.product.e911_state} ${this.product.e911_zip}`;
    },
  },
  watch: {
    product: {
      handler() {
        this.sync();
      },
      deep: true,
    },
    porting(newVal) {
      this.product.porting = newVal;
      // if (newVal === 'y') {
      //   // this.ensurePortArrays();
      //   // this.ensurePortRowBuffer();
      // }
    },
    tfNumbers(newVal) {
      this.product.tf_numbers = newVal;
    },
  },
  mounted() {
    this.product = _.cloneDeep(this.getProductInfo());

    if (this.product.business_name == null) {
      this.product.business_name = this.getQuoteFacts.company_name;
    }
    if (this.product.listing_company_name == null) {
      this.product.listing_company_name = this.getQuoteFacts.company_name;
    }

    // this.ensurePortArrays();
    if (this.porting === 'y') {
      // this.ensurePortRowBuffer();
    }

    if (!this.review) {
      this.hijackStepper(async (goRight) => {
        this.sync();
        await this.saveFiles();
        this.unHijackStepper();
        this.nextSubTab(goRight);
      });
    }
    // try to auto fill billing phone number
    if (!this.product.listing_phone) {
      this.contactsList.forEach((contact) => {
        if (contact.roles.includes("Billing Contact")) {
          this.product.listing_phone = contact.phone;
        }
      });
    }
    // if(this.product.listing_phone === ""){
    //   console.log(this.);
    //   //set to the billing contacts number!
    //  // or just do it in manage contacts! <--
    // }
  },
  beforeDestroy() {
    this.unHijackStepper();
  },
  methods: {
    ...mapActions(['syncFormData', 'hijackStepper', 'unHijackStepper', 'nextSubTab', 'uploadFiles', 'updateStoreFormData']),
    sync() {
      this.syncFormData({
        mainKey: this.getProductIdSelected,
        data: _.cloneDeep(this.product),
      });
    },
    // ensurePortArrays() {
    //   const phonesNull = this.product.loa_phone == null;
    //   const endsNull = this.product.loa_endrange_phone == null;

    //   if (phonesNull) {
    //     this.$set(this.product, 'loa_phone', []);
    //   }
    //   if (endsNull) {
    //     this.$set(this.product, 'loa_endrange_phone', []);
    //   }

    //   const phones = this.product.loa_phone;
    //   const ends = this.product.loa_endrange_phone;

    //   if (phones.length !== ends.length) {
    //     const maxLen = Math.max(phones.length, ends.length);
    //     while (phones.length < maxLen) {
    //       phones.push(null);
    //     }
    //     while (ends.length < maxLen) {
    //       ends.push(null);
    //     }
    //   }

    //   if (phones.length === 0) {
    //     for (let i = 0; i < this.initialRowCount; i += 1) {
    //       phones.push(null);
    //       ends.push(null);
    //     }
    //   }
    // },
    isTenDigitPhone(value) {
      const digits = String(value || '').replace(/\D/g, '');
      return digits.length === 10;
    },
    isRowCompletelyEmpty(i) {
      const start = (this.product.loa_phone || [])[i];
      const end = (this.product.loa_endrange_phone || [])[i];
      return !start && !end;
    },
    hasRange(i) {
      const end = (this.product.loa_endrange_phone || [])[i];
      return !!end;
    },
    displayPortRow(i) {
      const start = (this.product.loa_phone || [])[i];
      const end = (this.product.loa_endrange_phone || [])[i];
      if (!start && !end) {
        return '';
      }
      if (end) {
        return `${start}-${end}`;
      }
      return start;
    },
    findLastFilledIndex() {
      const phones = this.product.loa_phone || [];
      const ends = this.product.loa_endrange_phone || [];
      for (let i = phones.length - 1; i >= 0; i -= 1) {
        if (phones[i] || ends[i]) {
          return i;
        }
      }
      return -1;
    },
    // ensurePortRowBuffer() {
    //   if (this.product.porting !== 'y') {
    //     return;
    //   }

    //   this.ensurePortArrays();

    //   const phones = this.product.loa_phone;
    //   const ends = this.product.loa_endrange_phone;

    //   const lastFilled = this.findLastFilledIndex();
    //   const neededLen = Math.max(
    //     this.initialRowCount,
    //     (lastFilled + 1) + this.minEmptyTailRows,
    //   );

    //   while (phones.length < neededLen) {
    //     phones.push(null);
    //     ends.push(null);
    //   }

    //   while (phones.length > neededLen) {
    //     phones.pop();
    //     ends.pop();
    //   }
    // },
    onPortRowChanged() {
      this.ensurePortRowBuffer();
    },
    deleteRow(i) {
      this.product.loa_phone.splice(i, 1);
      this.product.loa_endrange_phone.splice(i, 1);
      this.ensurePortRowBuffer();
    },
    clearRange(i) {
      this.$set(this.product.loa_endrange_phone, i, null);
      this.ensurePortRowBuffer();
    },
    openRangeDialog(rowIndex) {
      const start = rowIndex == null ? '' : (this.product.loa_phone || [])[rowIndex];
      const end = rowIndex == null ? '' : (this.product.loa_endrange_phone || [])[rowIndex];

      this.rangeDialog.rowIndex = rowIndex;
      this.rangeDialog.start = start || '';
      this.rangeDialog.end = end || '';
      this.rangeDialog.touched = false;
      this.rangeDialog.valid = false;
      this.rangeDialog.open = true;

      this.$nextTick(() => {
        if (this.$refs.rangeForm) {
          this.$refs.rangeForm.resetValidation();
        }
      });
    },
    closeRangeDialog() {
      this.rangeDialog.open = false;
      this.rangeDialog.rowIndex = null;
      this.rangeDialog.start = '';
      this.rangeDialog.end = '';
      this.rangeDialog.touched = false;
      this.rangeDialog.valid = false;
    },
    rangeDialogTouched() {
      this.rangeDialog.touched = true;
      if (this.$refs.rangeForm) {
        this.$refs.rangeForm.validate();
      }
    },
    saveRange() {
      if (!this.$refs.rangeForm || !this.$refs.rangeForm.validate()) {
        return;
      }

      // this.ensurePortArrays();

      let targetIndex = this.rangeDialog.rowIndex;

      if (targetIndex == null) {
        const emptyIndex = this.firstEmptyRowIndex();
        targetIndex = emptyIndex != null ? emptyIndex : this.product.loa_phone.length;

        if (targetIndex === this.product.loa_phone.length) {
          this.product.loa_phone.push(null);
          this.product.loa_endrange_phone.push(null);
        }
      }

      this.$set(this.product.loa_phone, targetIndex, this.rangeDialog.start);
      this.$set(this.product.loa_endrange_phone, targetIndex, this.rangeDialog.end);

      this.closeRangeDialog();
      this.ensurePortRowBuffer();
    },
    setAddress(newAddress) {
      this.$set(this.product, 'loa_address', newAddress.streetAddress);
      this.$set(this.product, 'loa_suite', newAddress.suite);
      this.$set(this.product, 'loa_city', newAddress.city);
      this.$set(this.product, 'loa_state', newAddress.state);
      this.$set(this.product, 'loa_zip', newAddress.zip);
      this.$set(this.product, 'tf_address', newAddress.streetAddress);
      this.$set(this.product, 'tf_suite', newAddress.suite);
      this.$set(this.product, 'tf_city', newAddress.city);
      this.$set(this.product, 'tf_state', newAddress.state);
      this.$set(this.product, 'tf_zip', newAddress.zip);
    },
    sete911Address(newAddress) {
      console.log("setting");
      this.$set(this.product, 'e911_address', newAddress.streetAddress);
      this.$set(this.product, 'e911_city', newAddress.suite);
      this.$set(this.product, 'e911_city', newAddress.city);
      this.$set(this.product, 'e911_state', newAddress.state);
      this.$set(this.product, 'e911_zip', newAddress.zip);
    },
    setWhitePageAddress(newAddress) {
      console.log(`setting! ${JSON.stringify(newAddress)}`);
      this.$set(this.product, 'listing_address', newAddress.streetAddress);
      this.$set(this.product, 'listing_city', newAddress.suite);
      this.$set(this.product, 'listing_city', newAddress.city);
      this.$set(this.product, 'listing_state', newAddress.state);
      this.$set(this.product, 'listing_zip', newAddress.zip);
    },
    registerFileUpload(uploadedFiles) {
      this.uploadedFiles = Array.isArray(uploadedFiles) ? uploadedFiles : [];
    },
    async saveFiles() {
      if (this.uploadedFiles && this.uploadedFiles.length > 0) {
        await this.uploadFiles({
          uploadedFiles: this.uploadedFiles,
          tags: {
            field_name: 'loa_invoice',
          },
        });
      }
    },
    deleteNumber(i) {
      this.product.tf_phone.splice(i, 1);
      this.product.rtn_phone.splice(i, 1);
    },
    addNumber() {
      this.product.tf_phone.push(null);
      this.product.rtn_phone.push(null);
    },
    assignContact(e) {
      this.$set(this.product, 'tfc_auth_contact', e.fullname);
      this.$set(this.product, 'tfc_phone', e.phone);
    },
    setWhitePageAnswer(newVal) {
      this.updateStoreFormData({
        data: newVal,
        main: this.getProductIdSelected,
        sub: 'white_page_listing',
      });
    },
    setCallerIDName(newVal) {
      this.updateStoreFormData({
        data: newVal,
        main: this.getProductIdSelected,
        sub: 'caller_id',
      });
    },
    validateCid(newVal) {
      if (this.$refs.caller_id.validate()) this.setCallerIDName(newVal);
    },
  },
  components: {
    Porting,
    // Upload,
    TollfreePorting,
    // AddressAutocomplete,
    ReviewItem,
  },
};
</script>
